import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { ApiResponse } from '@Types/Api';
import type { CrossSell } from '@Types/Product';

export async function getCrossSell(productId: number) {
  const searchParams = new URLSearchParams({ shopProductId: productId.toString() }).toString();
  const url = `/backend/shop-product/cross-sell?${searchParams}`;

  const response = await Api.queryProxi<ApiResponse<CrossSell>>(url);

  if (!response.ok) {
    throw new BackendError(url, response);
  }

  return response.data;
}
